/**
 * Created by Макс on 16.10.2017.
 */
import { Component } from "@angular/core";
import { SingService } from "../service/sing.service";
import { HomeService } from "./services/home.service";
import { responseClientList } from "../class/http/res/response-client-list";
import { Client } from "../app/class/client";

@Component({
    selector: "home-app",
    templateUrl: "html/home.component.html",
    styleUrls: ["css/bootstrap-grid.min.css", "css/home.component.css"],
    providers: [SingService, HomeService]
})
export class HomeComponent {
    clients: Array<Client> = [];
    Auth: boolean = false;
    constructor(private action: HomeService) {}
    ngOnInit() {
        if (this.action.getAuthData().loggedIn !== "") {
            this.action.getClients().subscribe((data:responseClientList) => {
                  this.action.setClient(data.list);
                    this.Auth = true;
            });
        }
    }
    trackByIndex(index, item) {
        return index;
    }
    UpdateUrl(id: number): string {
        return `/rtb?id=${id}`;
    }
    UpdateBorder(id: number): string {
        return "1px solid #DDDDDD";
    }
}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts